"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@angular-redux/store");
var Observable_1 = require("rxjs/Observable");
var toast_service_1 = require("../../../shared/service/toast.service");
var AccessoryLocalComponent = /** @class */ (function () {
    function AccessoryLocalComponent(ngRedux, _toastService) {
        this.ngRedux = ngRedux;
        this._toastService = _toastService;
        this.pageNumber = 0;
        this.pageSize = 5;
        this.nextDisabled = false;
        this.txOnSelectedLocal = new core_1.EventEmitter();
        this.txGetPage = new core_1.EventEmitter();
        this.filter = [];
        this.filterIsOpened = false;
    }
    AccessoryLocalComponent.prototype.ngOnInit = function () {
        this.findLocals();
    };
    AccessoryLocalComponent.prototype.selectLocal = function (local) {
        if (this.ngRedux.getState().freeAccessoriesTotal === 0) {
            this.txOnSelectedLocal.emit(local);
        }
        else {
            this.showMessage('Finalize ou cancele a movimentação de acessórios.');
        }
    };
    AccessoryLocalComponent.prototype.previousPage = function () {
        if (this.pageNumber > 0) {
            this.pageNumber = this.pageNumber - 1;
            this.findLocals();
        }
    };
    AccessoryLocalComponent.prototype.nextPage = function () {
        if (!(this.locals.length === 0)) {
            this.pageNumber = this.pageNumber + 1;
            this.findLocals();
        }
    };
    AccessoryLocalComponent.prototype.goToPage = function (pageNumber) {
        this.pageNumber = pageNumber > 0 ? pageNumber - 1 : pageNumber;
        this.findLocals();
    };
    AccessoryLocalComponent.prototype.findLocals = function () {
        this.sanitizeFilter();
        this.txGetPage.emit({ pageNumber: this.pageNumber, pageSize: this.pageSize, localName: this.nameFilter });
    };
    AccessoryLocalComponent.prototype.openFilter = function () {
        this.filterIsOpened = true;
    };
    AccessoryLocalComponent.prototype.closeFilter = function () {
        this.pageNumber = 0;
        this.filterIsOpened = false;
        this.nameFilter = null;
        this.findLocals();
    };
    AccessoryLocalComponent.prototype.findByName = function () {
        this.pageNumber = 0;
        this.findLocals();
        this.filterIsOpened = false;
    };
    AccessoryLocalComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    AccessoryLocalComponent.prototype.sanitizeFilter = function () {
        if (!this.nameFilter || this.nameFilter.length < 1) {
            this.nameFilter = null;
        }
    };
    AccessoryLocalComponent.ctorParameters = function () { return [{ type: store_1.NgRedux }, { type: toast_service_1.ToastService }]; };
    __decorate([
        store_1.select('freeAccessoriesTotal'),
        __metadata("design:type", typeof (_a = typeof Observable_1.Observable !== "undefined" && Observable_1.Observable) === "function" && _a || Object)
    ], AccessoryLocalComponent.prototype, "freeAccessoriesTotal$", void 0);
    return AccessoryLocalComponent;
    var _a;
}());
exports.AccessoryLocalComponent = AccessoryLocalComponent;
//# sourceMappingURL=accessory-local.component.js.map


// WEBPACK FOOTER //
// accessory-local.component.js